/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
// import "bootstrap";
import Vue from "vue";
window.Vue = require('vue').default;


import Dexie from 'dexie';

const db = new Dexie('AppForet');
db.version(1).stores({
    pendingForms: '++id, url, data, timestamp',
    cache: 'url', // On utilise l'URL comme clé unique pour retrouver les données
    fileCache: 'url' //pour postandgetfiles
});
window.db = db //pour le rendre accessible dans les fichiers statiques public/js

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(reg => console.log('Proxy JS (Service Worker) activé !', reg))
            .catch(err => console.error('Erreur d’activation du SW', err));
    });
}

/**
 * Parcourt et envoie toutes les requêtes stockées en mode hors-ligne.
 */
async function syncOfflineData() {
    // On ne tente la synchro que si on est en ligne et que la DB est prête
    if (!navigator.onLine || !window.db) return;

    const database = window.db;
    const pending = await database.pendingForms.toArray();

    if (pending.length === 0) return;

    // console.log(`🔄 Connexion rétablie : Tentative de synchronisation de ${pending.length} élément(s)...`);

    showNetworkToast(`Synchronisation de ${pending.length} éléments en cours...`, "sync");

    let allSuccess = true;

    for (const item of pending) {
        try {
            // On reconstruit la requête originale
            const headers = {
                'Accept': 'application/json',
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            };

            let bodyData = item.data;
            // Si c'était un objet (provenant d'un FormData converti), on ne peut pas 
            // facilement le remettre en FormData sans connaître les fichiers, 
            // mais pour du JSON classique :
            if (!(bodyData instanceof FormData)) {
                headers['Content-Type'] = 'application/json';
                bodyData = JSON.stringify(item.data);
            }

            const response = await fetch(item.url, {
                method: item.method || 'POST',
                headers: headers,
                body: bodyData,
                credentials: 'include'
            });

            if (response.ok) {
                // Succès : on supprime cette ligne spécifique
                await database.pendingForms.delete(item.id);
                console.log(`✅ Synchro réussie pour : ${item.url}`);
            } else {
                allSuccess = false;
                console.error(`⚠️ Échec serveur pour ${item.url} (Status: ${response.status})`);
            }
        } catch (e) {
            allSuccess = false;
            console.error(`❌ Erreur réseau lors de la synchro pour ${item.url}`, e);
        }
    }

    if (allSuccess) {
        // UX: Succès final
        showNetworkToast("Application à jour. Données synchronisées avec succès.", "online");
        await window.db.cache.clear();
        await window.db.fileCache.clear();
    } else {
        showNetworkToast("Certains éléments n'ont pas pu être synchronisés.", "offline");
    }
}

/**
 * Affiche une notification à l'utilisateur
 */
function showNetworkToast(message, type = 'info') {
    const toast = document.getElementById('network-toast');
    if (!toast) return;

    // Couleurs selon l'état
    const colors = {
        online: '#28a745',  // Vert
        offline: '#dc3545', // Rouge
        sync: '#007bff'     // Bleu
    };

    toast.innerText = message;
    toast.style.backgroundColor = colors[type] || colors.info;
    toast.style.display = 'block';

    // On cache automatiquement après 4 secondes, sauf si c'est le mode hors-ligne fixe
    if (type !== 'offline') {
        setTimeout(() => {
            toast.style.display = 'none';
        }, 4000);
    }
}

// --- ÉCOUTEURS D'ÉVÉNEMENTS ---

const NetworkMonitor = {
    isCurrentlyOffline: null, // On part de inconnu

    init() {
        // 1. Écouteurs classiques
        window.addEventListener('online', () => this.updateStatus());
        window.addEventListener('offline', () => this.updateStatus());
        
        // 2. Intervalle de sécurité
        setInterval(() => this.updateStatus(), 5000);

        // 3. FORCE le premier check après un court instant (laisse le temps au DOM de charger)
        setTimeout(() => {
            this.updateStatus(true); // true = force l'affichage même si l'état semble identique
        }, 1000);
    },

    async updateStatus(force = false) {
        let isOffline = !navigator.onLine;

        // Si le navigateur dit "online", on vérifie réellement le serveur
        if (!isOffline) {
            try {
                // On ajoute un timestamp pour éviter le cache navigateur sur le ping
                const response = await fetch('/favicon.ico?t=' + Date.now(), { 
                    method: 'HEAD', 
                    cache: 'no-store' 
                });
                isOffline = !response.ok;
            } catch (e) { 
                isOffline = true; 
            }
        }

        // Si l'état change OU si on force (au rafraîchissement)
        if (isOffline !== this.isCurrentlyOffline || force) {
            this.isCurrentlyOffline = isOffline;
            
            if (isOffline) {
                // On s'assure que la fonction showNetworkToast existe bien avant d'appeler
                if (typeof showNetworkToast === 'function') {
                    showNetworkToast("⚠️ Mode Hors-ligne : les modifications sont stockées sur cet appareil.", "offline");
                }
            } else {
                if (typeof showNetworkToast === 'function') {
                    showNetworkToast("🌐 Connexion rétablie !", "online");
                }
                if (typeof syncOfflineData === 'function') {
                    syncOfflineData();
                }
            }
        }
    }
};

NetworkMonitor.init();

// 2. Vérifie au chargement de la page (si l'utilisateur ouvre l'app déjà connecté 
// mais qu'il reste des données de la veille)
window.addEventListener('load', () => {
    if (navigator.onLine) {
        // On laisse un petit délai pour s'assurer que la DB et le CSRF sont prêts
        setTimeout(syncOfflineData, 2000);
    }
});
// window.Trumbowyg.Table = require( 'trumbowyg/plugins/table/trumbowyg.table' );
// window.Trumbowyg.FontSize = require( 'trumbowyg/plugins/fontsize/trumbowyg.fontsize' );


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */



/* Ne fonctionne pas à voir */
// const files = require.context('./components/', true, /\.vue$/i);
// let cul = Object.values(files.keys());
// for(let i=0;i<cul.length;i++){
//     let component_name = cul[i].split('/').pop().split('.')[0];
//     component_name = component_name.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`).slice(1);
//     let component_path = './components'+cul[i].split('.')[1]+'.vue';
//     console.log(component_name,component_path);
//     Vue.component(component_name, () => import(component_path));
// }

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/* build de chaque .vue en .js */
// Administratif
Vue.component('monichon', () => import('./components/administratif/monichon.vue'));
Vue.component('formulaire_b1', () => import('./components/administratif/formulaire_b1.vue'));

// Autres
Vue.component('add-update-bug-confirmation', () => import('./components/autres/AddUpdateBugConfirmation.vue'));
Vue.component('add-update-bug-post', () => import('./components/autres/AddUpdateBugPost.vue'));
Vue.component('add-update-bug-thread', () => import('./components/autres/AddUpdateBugThread.vue'));
Vue.component('message-confirmation', () => import('./components/autres/MessageConfirmation.vue'));
Vue.component('modal-confirmation', () => import('./components/autres/ModalConfirmation.vue'));

// Contacts
// Vue.component('adresse', () => import('./components/contacts/Adresse.vue'));
// Vue.component('associate-contact', () => import('./components/contacts/AssociateContact.vue'));
// Vue.component('contact-only', () => import('./components/contacts/ContactOnly.vue'));
Vue.component('nouveau-contact', () => import('./components/contacts/modal/NouveauContact.vue'));
Vue.component('import-sage', () => import('./components/contacts/modal/ImportSage.vue'));
Vue.component('page-contact', () => import('./components/contacts/PageContact.vue'));


// Estimations
Vue.component('estimation', () => import('./components/estimations/Estimation.vue'));
Vue.component('estimation-menu', () => import('./components/estimations/EstimationMenu.vue'));
Vue.component('estimation-recap-communes', () => import('./components/estimations/EstimationRecapCommunes.vue'));
Vue.component('estimation-recap-entite', () => import('./components/estimations/EstimationRecapEntite.vue'));
Vue.component('estimation-recap-parcad', () => import('./components/estimations/EstimationRecapParcad.vue'));
Vue.component('estimation-recap-parcelles', () => import('./components/estimations/EstimationRecapParcelles.vue'));
Vue.component('estimation-recap-parcad', () => import('./components/estimations/EstimationRecapParcad.vue'));
Vue.component('estimation-table_communes_subtotals', () => import('./components/estimations/EstimationTable_communes_subtotals.vue'));
Vue.component('estimation-table', () => import('./components/estimations/EstimationTable.vue'));
Vue.component('estimation-table-hors-estimation', () => import('./components/estimations/EstimationTableHorsEstimation.vue'));
Vue.component('estimation-table-parcad', () => import('./components/estimations/EstimationTableParcad.vue'));

// Paramètres
Vue.component('articles', () => import('./components/parametre/Articles.vue'));
Vue.component('saisie-article', () => import('./components/parametre/modal/SaisieArticle.vue'));
Vue.component('presets', () => import('./components/parametre/Presets.vue'));
Vue.component('saisie-presets', () => import('./components/parametre/modal/SaisiePreset.vue'));
Vue.component('fiches', () => import('./components/parametre/Fiches.vue'));
Vue.component('formes-juridiques', () => import('./components/parametre/FormesJuridiques.vue'));
Vue.component('saisie-fiche', () => import('./components/parametre/modal/SaisieFiche.vue'));
Vue.component('prix-bois', () => import('./components/parametre/PrixBois.vue'));
Vue.component('acheteurs', () => import('./components/parametre/Acheteurs.vue'));
Vue.component('acheteurs-modal', () => import('./components/parametre/modal/AcheteursModal.vue'));
Vue.component('acheteurs-context-menu', () => import('./components/parametre/AcheteursContextMenu.vue'));
Vue.component('glossaires', () => import('./components/parametre/Glossaires.vue'));


// Projets
Vue.component('change-statut', () => import('./components/projets/ChangeStatut.vue'));
Vue.component('context-menu-projet', () => import('./components/projets/ContextMenuProjet.vue'));
Vue.component('dashboard-projet', () => import('./components/projets/DashboardProjet.vue'));
Vue.component('grid-alerte', () => import('./components/projets/GridAlerte.vue'));
Vue.component('grid-projet', () => import('./components/projets/GridProjet.vue'));
Vue.component('historique-statut', () => import('./components/projets/HistoriqueStatut.vue'));
Vue.component('itineraire-technique', () => import('./components/projets/modal/ItineraireTechnique.vue'));
Vue.component('map-projets', () => import('./components/projets/MapProjets.vue'));
Vue.component('context-menu-map-projets', () => import( './components/projets/ContextMenuMapProjets.vue' ));


// Projets - Nouvelle page (Nouveau projet)
Vue.component('page-projet', () => import('./components/projets/PageProjet.vue'));
Vue.component('contacts-searchbar', () => import('./components/projets/components/ContactsSearchbar.vue'));
Vue.component('projet-contact', () => import('./components/projets/components/ProjetContact.vue'));
Vue.component('projet-lieu', () => import('./components/projets/components/ProjetLieu.vue'));
Vue.component('projet-prestation', () => import('./components/projets/components/ProjetPrestation.vue'));
Vue.component('projet-recap', () => import('./components/projets/components/ProjetRecap.vue'));
Vue.component('projet-carto', () => import('./components/projets/components/ProjetCarto.vue'));
Vue.component('context-menu-carto-projets', () => import('./components/projets/components/ContextMenuCartoProjets.vue'));

// Propositions commerciales
Vue.component('context-menu-propal', () => import('./components/propositions_commerciales/ContextMenuPropal.vue'));
Vue.component('propal-body', () => import('./components/propositions_commerciales/components/PropalBody.vue'));
Vue.component('propal-budget', () => import('./components/propositions_commerciales/components/PropalBudget.vue'));
Vue.component('propal-carto', () => import('./components/propositions_commerciales/components/PropalCarto.vue'));
Vue.component('propal-header', () => import('./components/propositions_commerciales/components/PropalHeader.vue'));
Vue.component('propal-mandat', () => import('./components/propositions_commerciales/components/PropalMandat.vue'));
Vue.component('propal-preview', () => import('./components/propositions_commerciales/components/PropalPreview.vue'));
Vue.component('propal-preview-minimap', () => import('./components/propositions_commerciales/components/PropalPreviewMinimap.vue'));
Vue.component('propal-preview-bc-web', () => import('./components/propositions_commerciales/components/PropalPreviewBcWeb.vue'));
Vue.component('propal-livrables', () => import('./components/propositions_commerciales/components/PropalLivrables.vue'));
Vue.component('livrable-preview', () => import('./components/propositions_commerciales/components/LivrablePreview.vue'));
Vue.component('propal-preview-print', () => import('./components/propositions_commerciales/components/PropalPreviewPrint.vue'));
Vue.component('proposition-commerciale-create', () => import('./components/propositions_commerciales/modal/PropositionCommercialeCreate.vue'));
Vue.component('documents', () => import( './components/propositions_commerciales/components/Documents.vue' ) );
Vue.component('propal-glossaire-modal', () => import( './components/propositions_commerciales/components/PropalGlossaireModal.vue' ) );
Vue.component('propal-swap-article-modal', () => import( './components/propositions_commerciales/modal/PropalSwapArticleModal.vue' ) );


// Chantiers
Vue.component('dashboard-chantier', () => import('./components/chantiers/DashboardChantier.vue'));
Vue.component('map-chantier', () => import('./components/chantiers/MapChantier.vue'));
Vue.component('chantier-edit', () => import('./components/chantiers/modal/ChantierEdit.vue'));
Vue.component('chantier-carto', () => import('./components/chantiers/components/ChantierCarto.vue'));
Vue.component('chantier-body', () => import('./components/chantiers/components/ChantierBody.vue'));
Vue.component('chantier-body-context-menu', () => import('./components/chantiers/components/ChantierBodyContextMenu.vue'));
Vue.component('chantier-ligne', () => import('./components/chantiers/components/ChantierLigne.vue'));
Vue.component('chantier-foret-data', () => import('./components/chantiers/components/ChantierForetData.vue'));
Vue.component('chantier-capture', () => import('./components/chantiers/components/ChantierCapture.vue'));
Vue.component('chantier-plans', () => import('./components/chantiers/components/ChantierPlans.vue'));
Vue.component('chantier-preview', () => import('./components/chantiers/components/ChantierPreview.vue'));
Vue.component('chantier-preview-print', () => import('./components/chantiers/components/ChantierPreviewPrint.vue'));
Vue.component('context-menu-chantier', () => import( './components/chantiers/components/ContextMenuChantier.vue' ));
Vue.component('context-menu-map-chantier', () => import( './components/chantiers/components/ContextMenuMapChantier.vue' ));
Vue.component('chantier-swap-article-modal', () => import( './components/chantiers/components/ChantierSwapArticleModal.vue' ));


// Factures
Vue.component('dashboard-facture', () => import('./components/factures/DashboardFacture.vue'));
Vue.component('facture-edit', () => import('./components/factures/modal/FactureEdit.vue'));
Vue.component('facture-carto', () => import('./components/factures/components/FactureCarto.vue'));
Vue.component('facture-body', () => import('./components/factures/components/FactureBody.vue'));
Vue.component('context-menu-map-facture', () => import( './components/factures/components/ContextMenuMapFacture.vue' ));

// Webmapping
Vue.component('proposition-commerciale-carto', () => import('./components/webmapping/PropositionCommercialeCarto.vue'));

// Risques
Vue.component('carto-risques', () => import('./components/risques/CartoRisques.vue'));

// Composants génériques
Vue.component('filters-header', () => import('./components/FiltersHeader.vue'));
Vue.component('multi-select', () => import('./components/MultiSelect.vue'));
Vue.component('multi-search', () => import('./components/MultiSearch.vue'));
Vue.component('numeric-input', () => import('./components/NumericInput.vue'));
Vue.component('prix', () => import('./components/Prix.vue'));
Vue.component('search-bar', () => import('./components/SearchBar.vue'));
Vue.component('toaster', () => import('./components/Toaster.vue'));


// Dendrometrie
Vue.component('dendrometrie-compas', () => import('./components/dendrometrie/DendrometrieCompas.vue'));
Vue.component('dendrometrie-map', () => import('./components/dendrometrie/DendrometrieMap.vue'));
Vue.component('dendrometrie-sondage', () => import('./components/dendrometrie/DendrometrieSondage.vue'));
Vue.component('dendrometrie-gauss', () => import('./components/dendrometrie/DendrometrieGauss.vue'));
Vue.component('dendrometrie-mauge', () => import('./components/dendrometrie/DendrometrieMauge.vue'));

// Mandats et Mises en vente
Vue.component('mise-en-vente', () => import('./components/mises_en_vente/MiseEnVente.vue'));
Vue.component('mise-en-vente-editor', () => import('./components/mises_en_vente/MiseEnVenteEditor.vue'));
Vue.component('mise-en-vente-couverture-map', () => import('./components/mises_en_vente/MiseEnVenteCouvertureMap.vue'));
Vue.component('mise-en-vente-instruction-couverture-map', () => import('./components/mises_en_vente/MiseEnVenteInstructionCouvertureMap.vue'));
Vue.component('mise-en-vente-chantier-map', () => import('./components/mises_en_vente/MiseEnVenteChantierMap.vue'));
Vue.component('mise-en-vente-minimap', () => import('./components/mises_en_vente/MiseEnVenteMinimap.vue'));
Vue.component('mise-en-vente-context-menu', () => import('./components/mises_en_vente/MiseEnVenteContextMenu.vue'));
Vue.component('mise-en-vente-fiche-instruction-map', () => import('./components/mises_en_vente/MiseEnVenteFicheInstructionMap.vue'));
Vue.component('mise-en-vente-projections', () => import('./components/mises_en_vente/MiseEnVenteProjections.vue'));
Vue.component('mise-en-vente-consultation', () => import('./components/mises_en_vente/MiseEnVenteConsultation.vue'));
Vue.component('mise-en-vente-consultations-des-ventes', () => import('./components/mises_en_vente/MiseEnVenteConsultationsDesVentes.vue'));
Vue.component('mise-en-vente-consultation-context-menu', () => import('./components/mises_en_vente/MiseEnVenteConsultationContextMenu.vue'));
Vue.component('mise-en-vente-produits', () => import('./components/mises_en_vente/MiseEnVenteProduits.vue'));
Vue.component('mise-en-vente-comptage', () => import('./components/mises_en_vente/MiseEnVenteComptage.vue'));
Vue.component('mise-en-vente-comptage-chart', () => import('./components/mises_en_vente/MiseEnVenteComptageChart.vue'));
Vue.component('mise-en-vente-contrat-vente-bois', () => import('./components/mises_en_vente/MiseEnVenteContratVenteBois.vue'));
Vue.component('mise-en-vente-milieux-sensibles-map', () => import('./components/mises_en_vente/MiseEnVenteMilieuxSensiblesMap.vue'));
Vue.component('mise-en-vente-fiche-instructions', () => import('./components/mises_en_vente/MiseEnVenteFicheInstructions.vue'));
Vue.component('mise-en-vente-fiche-reception-contradictoire', () => import('./components/mises_en_vente/MiseEnVenteFicheReceptionContradictoire.vue'));
Vue.component('mise-en-vente-contrat-glossaires', () => import('./components/mises_en_vente/modal/MiseEnVenteContratGlossaires.vue'));


//Reporting
Vue.component('dashboard-suivi-client', () => import('./components/reporting/DashboardSuiviClient.vue'));
Vue.component('dashboard-encours', () => import('./components/reporting/DashboardEncours.vue'));


/*
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('test-component', require('./components/TestComponent.vue').default);

// Contacts
Vue.component('dialog-contact', require('./components/contacts/NouveauContact.vue').default);
Vue.component('contact-only', require('./components/contacts/ContactOnly.vue').default);
Vue.component('dialog-adresse', require('./components/contacts/Adresse.vue').default);
Vue.component('associate-contact', require('./components/contacts/AssociateContact.vue').default);

// Projets
Vue.component('grid-projet', require('./components/projets/GridProjet.vue').default);
Vue.component('changeStatut', require('./components/projets/ChangeStatut.vue').default);
Vue.component('historiqueStatut', require('./components/projets/HistoriqueStatut.vue').default);




// Autres
Vue.component('modal-confirmation', require('./components/autres/ModalConfirmation.vue').default);
Vue.component('message-confirmation', require('./components/autres/MessageConfirmation.vue').default);
Vue.component('add-update-bug-confirmation', require('./components/autres/AddUpdateBugConfirmation.vue').default);
Vue.component('add-update-bug-thread', require('./components/autres/AddUpdateBugThread.vue').default);
Vue.component('add-update-bug-post', require('./components/autres/AddUpdateBugPost.vue').default);

*/
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
